/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetUserChatSettingsViewDto } from './getUserChatSettingsViewDto';


export interface ChatEventChatSettingsChangedContentDto { 
    /**
     * Id чата
     */
    chatId: string;
    settings: GetUserChatSettingsViewDto;
}

